// extracted by mini-css-extract-plugin
export var csatScore = "_il-5";
export var header = "_il-1";
export var panelWrapper = "_il-2";
export var postPreview = "_il-3";
export var rightContent = "_il-0";
export var wrappingText = "_il-4";